import { render, staticRenderFns } from "./complaintTypeList.vue?vue&type=template&id=03b371b2&scoped=true"
import script from "./complaintTypeList.vue?vue&type=script&lang=js"
export * from "./complaintTypeList.vue?vue&type=script&lang=js"
import style0 from "./complaintTypeList.vue?vue&type=style&index=0&id=03b371b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b371b2",
  null
  
)

export default component.exports